import React from "react";
import { dialog, Button } from "nq-component";
import Table from "../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import { InfiniteScroll } from "nq-component";
import withRouter from "../../../withRouter";
import Search from "../../../components/Search";
import BaseListPage from "../../../base/BaseListPage";
import CardView from "../../../components/common/CardView";
import EmployeeEarningsPresenter from "./EmployeeEarningsPresenter";
import EmployeeEarningsFormPage from "./employee-earnings-form/EmployeeEarningsFormPage";
import Progress from "../../../components/Progress";

class DisbursementsPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.state = {
      objects: [],
      limit: 10,
      current: 1,
      count: 0,
      panelState: {
        isBasicModal: false,
        isApModal: false,
      },
    };
    this.presenter = new EmployeeEarningsPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const [otherDeduction, contributions] = await Promise.all([
      findObjectUseCase().execute("accounts_title", {}),
      findObjectUseCase().execute("contribution_type"),
    ]);

    const { DEDUCTIONS } = otherDeduction.reduce(
      (acc, item) => {
        acc.DEDUCTIONS.push(item?.name);
        return acc;
      },
      { DEDUCTIONS: [] }
    );

    const contributionType = contributions.map((item) => item.contributionType);

    this.setState((prevState) => ({
      panelState: {
        ...prevState.panelState,
        deductions: DEDUCTIONS,
        contributionType,
      },
    }));
  }

  getCollectionName() {
    return "employees";
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count, limit, current, panelState } = this.state;

    const includeLabel = Object.keys(schema.fields).filter(
      (fields) =>
        fields !== "agency" &&
        fields !== "Firstname" &&
        fields !== "Middlename" &&
        fields !== "surname"
    );
    if (!schema) return <Progress />;

    return (
      <>
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            // hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} Finance {">"}{" "}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    Employee Earnings
                  </span>
                </p>
              </div>
              <CardView style={{ borderRadius: 0 }}>
                <Search
                  schemas={this.getSchemas()}
                  onSubmit={this.searchSubmit.bind(this)}
                  fields={schema.fields}
                />
              </CardView>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center">
                    <h4 className="text-primary">Employee Earnings</h4>
                  </div>
                </CardView>
              </div>

              <Table
                viewAP={(data) => this.presenter.onEarningsChange(data, "ap")}
                viewBasic={(data) =>
                  this.presenter.onEarningsChange(data, "basic")
                }
                progress={loading}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-three-dots-vertical" />,
                    actionType: "Employee Earnings",
                  },
                ]}
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["Id", "Created At", "Updated At", ...includeLabel]
                )}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
        {panelState.isBasicModal && (
          <EmployeeEarningsFormPage
            closeFloating={() => this.presenter.onCloseFloating()}
            panelInfo={{
              employeeInfo: panelState.employeeInfo,
              payrollType: panelState.payrollType,
              payrollIds: panelState.payrollIds,
              backPayIds: panelState.backPayIds,
              payrollPrinted: panelState.payrollPrinted,
              deductions: panelState.deductions,
              contributionType: panelState.contributionType,
            }}
          />
        )}
      </>
    );
  }
}

export default withRouter(DisbursementsPage);
